import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'agenda-customer-ui-maintenance-page',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './app-maintenance.component.html',
  styleUrls: ['./app-maintenance.component.scss'],
  providers: [TranslateService],
})
export class AppMaintenancePageComponent { }
